import React from "react";
import Upload from "./Upload";

const documentsList = [
  {
    name: "project_design",
    label: "Project Design Document (PDD)",
    number: 1,
    allowedFileTypes: [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "application/pdf",
    ],
  },
  {
    name: "legal_compliance",
    label: "Legal compliance documentation",
    number: 1,
    allowedFileTypes: [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "application/pdf",
    ],
  },
  {
    name: "environmental_impact_assessment",
    label: "Environmental impact assessment document",
    number: 1,
    allowedFileTypes: [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "application/pdf",
    ],
  },
  {
    name: "issuance_representation",
    label: "Issuance representation",
    number: 1,
    allowedFileTypes: [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "application/pdf",
    ],
  },
  {
    name: "monitoring_report",
    label: "Monitoring report",
    number: 1,
    require: false,
    allowedFileTypes: [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "application/pdf",
    ],
  },
  {
    name: "verification_report",
    label: "Verification report",
    number: 1,
    require: false,
    allowedFileTypes: [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "application/pdf",
    ],
  },
  {
    name: "validation_report",
    label: "Validation report",
    number: 1,
    require: false,
    allowedFileTypes: [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "application/pdf",
    ],
  },
  {
    name: "project_images",
    label: "Project Images (At least 4)",
    number: 4,
    require: false,
    allowedFileTypes: [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "application/pdf",
    ],
  },
  {
    name: "proof_of_validation_contraction",
    label: "Proof of validation contracting",
    number: 1,
    require: false,
    allowedFileTypes: [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "application/pdf",
    ],
  },


  {
    name: "validation_representation",
    label: "Validation representation",
    number: 1,
    require: false,
    allowedFileTypes: [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "application/pdf",
    ],
  },

  {
    name: "issuance_report",
    label: "Issuance report",
    number: 1,
    require: false,
    allowedFileTypes: [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "application/pdf",
    ],
  },
  {
    name: "SDG_certification",
    label: "SDG Certificate",
    number: 1,
    require: false,
    allowedFileTypes: [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "application/pdf",
    ],
  },
  {
    name: "project_video",
    label: "Project Video",
    require: false,
    number: 1,
    allowedFileTypes: ["video/mp4"],
  },
  {
    name: "verification_representation",
    label: "Verification representation",
    number: 1,
    require: false,
    allowedFileTypes: [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "application/pdf",
    ],
  },
  {
    name: "registration_representation",
    label: "Registration representation",
    number: 1,
    require: false,
    allowedFileTypes: [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "application/pdf",
    ],
  },

 
  {
    name: "evidence_project_ownership",
    label: "Evidence of Project ownership/proponents",
    number: 1,
    require: false,
    allowedFileTypes: [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "application/pdf",
    ],
  },
  {
    name: "listing_representation",
    label: "Listing representation",
    number: 1,
    require: false,
    allowedFileTypes: [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "application/pdf",
    ],
  },
];

const DocumentRequired = ({ setDocuments, documents }) => {
  const leftColumn = [];
  const rightColumn = [];

  documentsList.forEach((doc, index) => {
    if (index % 2 === 0) {
      leftColumn.push({ ...doc, index });
    } else {
      rightColumn.push({ ...doc, index });
    }
  });

  return (
    <div className="flex">
      <div className="w-1/2 pr-8">
        <ol className="list-none">
          {leftColumn.map(
            ({ name, label, number, allowedFileTypes, require, index }) => (
              <li key={name}>
                <Upload
                  name={name}
                  label={label}
                  number={number}
                  index={index}
                  uploadList={documents[name]}
                  setDocuments={setDocuments}
                  allowedFileTypes={allowedFileTypes}
                  require={require}
                />
              </li>
            )
          )}
        </ol>
      </div>

      <div className="w-1/2 pl-2">
        <ol className="list-none">
          {rightColumn.map(
            ({ name, label, number, allowedFileTypes, require, index }) => (
              <li key={name}>
                <Upload
                  name={name}
                  label={label}
                  number={number}
                  index={index}
                  uploadList={documents[name]}
                  setDocuments={setDocuments}
                  allowedFileTypes={allowedFileTypes}
                  require={require}
                />
              </li>
            )
          )}
        </ol>
      </div>
    </div>
  );
};

export default DocumentRequired;
